module.exports = __webpack_public_path__ + "img/20200304152705360截图20190822214528717.17b3b906.jpg";